// cSpell: disable
import { useCallback } from 'react';

import { SafeHtml } from '@bcp-channels-sharedcomponents-reactjs/core';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import {
	BaseModal,
	Box,
	Button,
	CSSProperties,
	ComposedElement,
	Overlay,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Close, Lightning } from '@bcp-nextgen-dx-component-factory/icons-foundation';
import { useGetCurrentBreakpoint, useHideScroll, useIsVisibleModal, useModal } from '@hooks';
import { useServicesStore } from '@store';

export const AdjustedPaymentTermSimulationModalAb = () => {
	const { currentView } = useGetCurrentBreakpoint();
	const { enable: enableScroll } = useHideScroll();
	const translate = useTranslation();
	const { hide: hideAdjustedPaymentTermSimulation } = useModal('adjustedPaymentTermSimulationModal');
	const { colorPalette } = useTheme();
	const simulationOverview = useServicesStore((state) => state.simulationOverview);
	const isVisible = useIsVisibleModal('adjustedPaymentTermSimulationModal');

	const handleOnClickClose = useCallback(() => {
		enableScroll();
		hideAdjustedPaymentTermSimulation();
	}, [hideAdjustedPaymentTermSimulation]);

	const generalStyles = {
		modalConfig: {
			background: '#FFFFFF',
			borderRadius: '24px',
		},
		modalContent: {
			flexDirection: 'column',
			padding: '32px',
		},
		bigIconBox: {
			justifyContent: 'center',
			marginBottom: '24px',
		},
		closeButtonBox: {
			alignSelf: 'end',
		},
		messageBox: {
			textAlign: 'center',
			rowGap: '8px',
			flexDirection: 'column',
			marginBottom: '24px',
		},
	};

	const styles = {
		...generalStyles,
		smallView: {
			...generalStyles,
			modalConfig: {
				...generalStyles.modalConfig,
				width: 'calc(100vw - 28px)',
			},
		},
		tabletView: {
			...generalStyles,
			modalConfig: { ...generalStyles.modalConfig, width: '536px' },
			messageBox: { ...generalStyles.messageBox, padding: '0 16px' },
		},
		bigView: {
			...generalStyles,
			modalConfig: { ...generalStyles.modalConfig, width: '536px' },
		},
	};

	return (
		<BaseModal visible={isVisible} externalBackdrop={<Overlay onPress={handleOnClickClose} />}>
			<Box styles={styles[currentView].modalConfig}>
				<Box styles={styles[currentView].modalContent as CSSProperties}>
					<Box styles={styles[currentView].closeButtonBox} onPress={handleOnClickClose}>
						<ComposedElement
							container={{
								styles: {
									background: colorPalette.color_01[70],
								},
							}}
							fill={colorPalette.color_01[100]}
							icon={{
								source: Close.Outline,
							}}
						/>
					</Box>
					<Box styles={styles[currentView].bigIconBox}>
						<ComposedElement
							container={{
								styles: {
									background: colorPalette.color_02[100],
									marginTop: '-95px',
									border: '6px solid #FFF',
								},
							}}
							size="huge"
							fill="#FFF"
							icon={{
								source: Lightning.Outline,
							}}
						/>
					</Box>
					<Box styles={styles[currentView].messageBox as CSSProperties}>
						<Typography
							appearance={
								currentView === 'smallView'
									? 'subtitle-100-02'
									: currentView === 'tabletView'
									? 'headline-75-01'
									: 'body-400-03'
							}
						>
							{translate('simulator.modals.adjustedPaymentTermSimulation.termAdjusted')}
						</Typography>
						<Typography appearance={currentView === 'bigView' ? 'subtitle-100-01' : 'body-100-01'}>
							<SafeHtml html={simulationOverview?.adjustedTermMessages?.modal as string} />
						</Typography>
					</Box>
					<Box styles={{ justifyContent: 'center' }}>
						<Button size="large" fixedWidth={currentView === 'smallView'} onPress={handleOnClickClose}>
							{translate('simulator.modals.adjustedSimulation.seeCalculation')}
						</Button>
					</Box>
				</Box>
			</Box>
		</BaseModal>
	);
};
